import React, { useState, useEffect, useRef, act } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import useGlobalStore from '../../store/globalStore'; // Import useGlobalStore
import { Navigation, Pagination } from "swiper/modules";
// import ZoomModal from "../ZoomModal/ZoomModal"; // No longer rendered here
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// --- Import Button Images ---
import prevButtonImage from '../../assets/UI/button_arrow_back.svg'; // Adjust path if needed
import nextButtonImage from '../../assets/UI/button_arrow_next.svg'; // Adjust path if needed
import zoomInImage from '../../assets/UI/button_zoom_in.svg'; // Adjust path if needed
import closeButtonImage from '../../assets/UI/button_close.svg'; // Import close image
import closeLineButtonImage from '../../assets/UI/line_close.svg'; // Import close image
import moreInfoButtonImage from '../../assets/UI/button_more_info.svg';
import moreInfoSmallButtonImage from '../../assets/UI/button_more_info_mobile.svg';
import videoButtonImage from '../../assets/UI/icon_video.svg';
import qrCodeImage from '../..//assets/UI/Microsite_QR_Code.png';

import parse from 'html-react-parser';

import './CarouselGallery.css';

const CarouselGallery = ({ selectedSlide, onClose, onOpenMediaItemRequest, isModal=false, initialSlideIndex=0, mode = 'carousel', customQrCodeAudioImage=null }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  // Removed popupSrc, popupType, popupCaption states
  const swiperRef = useRef(null);
  //const swiperUse = useSwiper();
  //console.log("swiperUse", swiperUse, swiperRef);
  const isElectron = useGlobalStore((state) => state.isElectron); // Get isElectron state
  const isDesktop = useGlobalStore((state) => state.isDesktop);
  //const qrCodeAudio = useGlobalStore((state) => state.qrCodeAudio);
  //const setAudioQrCode = useGlobalStore((state) => state.setAudioQrCode);
  const navigate = useNavigate(); // Initialize useNavigate

  //console.log("customQrCodeAudioImage", customQrCodeAudioImage);

  
  useEffect(() => {
    //console.log("CarouselGallery:navigate", navigate);
    console.log("CarouselGallery:selectedSlide changed", selectedSlide);
    document.activeElement.blur();
    if(swiperRef.current) {
      console.log("focus up swiperRef.current");
      swiperRef.current.focus();
      // setTimeout(() => {
      //   console.log('reset', document.activeElement);
      //   //document.activeElement.blur();
      // }, 1000); // 5 seconds delay
    }
  }, [selectedSlide, swiperRef]);

  // --- Helper Function to Open Modal ---
  const requestOpenMediaItem = (itemToOpenInModal) => {
    // Ensure both itemToOpenInModal and selectedSlide (the parent "story" or direct item) are valid
    if (!itemToOpenInModal || !itemToOpenInModal.id || !selectedSlide || !selectedSlide.id) {
      console.warn("[CarouselGallery] Attempted to open modal with invalid item:", itemToOpenInModal);
      return;
    }
    console.log(`[CarouselGallery] Requesting to open media item:`, itemToOpenInModal);
    
    // Call the prop passed from App.js to actually set modal content
    if (onOpenMediaItemRequest) {
      onOpenMediaItemRequest(itemToOpenInModal); // This tells App.js to setModalContent
      // Update URL to include media item ID as a query parameter, relative to the selectedSlide's ID
      navigate(`/gallery/${selectedSlide.urlId}?media=${itemToOpenInModal.id}`);
    }
  };


  // Helper to safely render HTML
  const createMarkup = (htmlString) => {
    //return parse(htmlString);
    return { __html: htmlString || "" };
  };


  // Helper to check if the current selectedSlide has media items
  const hasMediaSlides = (slide) => {
    return slide && Array.isArray(slide.media_item) && slide.media_item.length > 0;
  };

  // const currentMediaSlideData = hasMediaSlides(selectedSlide) && selectedSlide.media.length > activeIndex
  //   ? selectedSlide.media[activeIndex]
  //   : null;

  return (
    <div className="gallery-container-wrapper">
     <div className={`gallery-container ${isModal ? 'gallery-container-modal' : ''}`}>

      {/* Render Swiper or Placeholder */}
      {hasMediaSlides(selectedSlide) && (
        <>

          {mode === 'carousel' && (
            <>
              {/* Swiper and its custom nav buttons */}
              <Swiper
                // tabIndex='299'
                ref={swiperRef}
                observer={true}
                observeParents={true}
                slidesPerView={1}
                initialSlide={initialSlideIndex}
                spaceBetween={0}
                loop={true}
                pagination={{ clickable: true }} // Keep pagination if needed
                // Configure navigation to use custom elements
                navigation={{ nextEl: '.carousel-custom-next', prevEl: '.carousel-custom-prev' }}
                // navigation={true}
                modules={[Pagination, Navigation]}
                className="gallery-wrapper no-select"
                onSlideChange={(swiper) => {
                  console.log("Swiper slide changed to index:", swiper.realIndex);
                  setActiveIndex(swiper.realIndex);
                }}
                onInit={(swiper) => {
                  console.log("Swiper initialized in CarouselGallery");
                }}
              >
                {selectedSlide.media_item.map((media, index) => (
                  <SwiperSlide key={media.full_resolution_image || media.video_src || index}>
                    <div
                      className="swiper-zoom-container"
                      onClick={() => requestOpenMediaItem(media)} // Call new handler
                      role="button"
                      //tabIndex={index === activeIndex ? '500' : '-1'}
                      // onKeyDown={(e) => {
                      //   if (e.key === 'Enter' || e.key === ' ') {
                      //     e.preventDefault();
                      //     requestOpenMediaItem(media);
                      //   }
                      // }}
                      //tabIndex={0}
                    >
                      {/* Conditionally render img or a video placeholder/icon */}
                      {/* {media.type === 'video' ? (
                        <div className="video-placeholder">▶️ Video<img
                        src={media.thumbnail_src}
                        alt={media.title || selectedSlide.title || `Gallery image ${index + 1}`}
                        className="gallery-image"
                        loading="lazy"
                      /></div> // Simple placeholder
                      ) : (
                        <img
                          src={media.thumbnail_src}
                          alt={media.title || selectedSlide.title || `Gallery image ${index + 1}`}
                          className="gallery-image"
                          loading="lazy"
                        />
                      )} */}

                      {/* Conditionally render img or a video placeholder/icon */}
                      <div className="gallery-item" 
                        tabIndex={index === activeIndex ? '500' : '-1'}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            console.log("keydown", media);
                            requestOpenMediaItem(media);
                          }
                        }}
                      >
                        <img
                            src={media.thumbnail_src || media.thumbnail}
                            alt={media.title || selectedSlide.title || `Gallery image ${index + 1}`}
                            className="gallery-image"
                            loading="lazy"
                            // loading={isElectron ? undefined : "lazy"} // Conditionally apply lazy loading
                          />
                          {media.type === 'video' && (
                            <div className="video-placeholder"><img src={videoButtonImage} alt="Play video" /></div> // Simple placeholder
                          )}
                          {/* --- Add Caption Display --- */}
                          {media.short_caption_and_credit && (
                            <div className="gallery-item-caption">{parse(media.short_caption_and_credit)}</div>
                          )}
                           {/* --- the bottom right zoom in button which activates a zoommodal --- */}
                          {media.type !== 'video' && (
                            <div className="zoom-placeholder"><img src={zoomInImage} alt="Zoom in" /></div>
                          )}
                          
                          {/* --- End Caption Display --- */}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              {/* --- Custom Navigation Buttons (Positioned relative to gallery-wrapper) --- */}
              {selectedSlide.media_item.length > 1 && (
                <>
              <div className="carousel-custom-nav carousel-custom-prev" role="button" aria-label="Previous slide" tabIndex='550'
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (swiperRef.current && swiperRef.current.swiper) {
                      swiperRef.current.swiper.slidePrev();
                    }
                  }
                }}
              >
                <img src={prevButtonImage} alt="Previous" />
              </div>
              <div className="carousel-custom-nav carousel-custom-next" role="button" aria-label="Next slide" tabIndex='551'
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (swiperRef.current && swiperRef.current.swiper) {
                      swiperRef.current.swiper.slideNext();
                    }
                  }
                }}
              >
                <img src={nextButtonImage} alt="Next" />
              </div>
                </>
              )}
              

              
            </>
          )}

          

          <div className={`gallery-info ${mode === 'static' ? 'mode-static' : ''}`} >

              {/* gradient at top */}
          <div className={`header-grad ${mode === 'static' ? 'mode-static' : ''}`}></div>
              
              {/* ... info content ... */}
              <div className={`gallery-info-content ${mode === 'static' ? 'mode-static' : ''}`} >
                {selectedSlide ? (
                  <>
                    <h2 className="gallery-title text-left" >
                      {parse(selectedSlide.title)}
                    </h2>
                    {(!isElectron && selectedSlide.id_number ) &&  (
                      <h3 className="gallery-subtitle text-left" >{parse(selectedSlide.id_number)}</h3>
                    )}
                    {/* <h3 className="gallery-subtitle text-left">
                      {selectedSlide.subtitle}
                    </h3> */}
                    {/* <h3 className="gallery-subtitle text-left">
                      Optional subtitle 2
                    </h3> */}
                    
                    <div
                      className="gallery-description text-left"                      
                    >{parse(selectedSlide.about)}</div>
                  </>
                ) : (
                  <p>Select an item from the grid.</p>
                )}
              </div>

              {mode === 'static' && (
                <div className="qr-placeholder"><img src={ (selectedSlide.type === "video-qr") ? customQrCodeAudioImage : qrCodeImage} alt="QR Code" /></div>
              )}

              
              {/* External Link - web only. FIXME: move out of the scroll container as the top white gradient was covering OR delete/hide the white gradient */}
              {( (selectedSlide.link ) && !isElectron) && (
                <div className="gallery-external-link">
                  <a href={selectedSlide.link ? selectedSlide.link : "https://google.com"} target="_blank" rel="noopener noreferrer">
                  { isDesktop ? 
                    <img className="more-info-img" src={moreInfoButtonImage} alt="More info"  /> : 
                    <img className="more-info-img-small" src={moreInfoSmallButtonImage} alt="More info"  />
                  }
                  </a>
                </div>
              )}

          </div>

          

          
          {/* Close button is now inside gallery-info */}
          <div className={`footer-close ${mode === 'static' ? 'mode-static' : ''}`}>
            <button
              className={`carousel-view-close-button ${mode === 'static' ? 'mode-static' : ''}`}
              onClick={onClose}
              //tabIndex='100'
              aria-label="Close gallery view"
            >
              <span>Close</span> <img src={closeLineButtonImage} alt="Close" />
            </button>
          </div>
        </>


      )}

    </div>
    </div>
  );
};

export default CarouselGallery;
